import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        // For NEW Google sign-ups we default the role to self_study_student (no institute
        // assumed). Existing accounts keep their role/institute server-side.
        const url = "/auth/google/session?role=self_study_student";
        const { data } = await http.post(url, { session_id });
        await refresh();
        const role = data.user.role;
        navigate(
          role === "institute_admin" ? "/institute" :
          role === "self_study_student" ? "/selfstudy" :
          "/student",
          { replace: true }
        );
      } catch (e) {
        console.error(e);
        navigate("/login?google_error=1", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#7A7369]" data-testid="auth-callback-loading">
      Finishing sign in…
    </div>
  );
}
